import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Thankyou_content from "../components/component-thankyou";

function Thankyou(){

    return(
        <>
            <ChangePageTitle pageTitle="رسید پرداخت | رستوران باغبان" />
            <Thankyou_content />
        </>
    );

}

export default Thankyou;